<!-- 个人采购订单 -->
<template>
  <div class='page_content'>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="refresh" :showRefresh="true" :buttonFlag="false"></v-button>

      <div class="page_content_top_line">
        <vSearch  :flagList="['tpId']" @searchData="getDataList"  
               :getRequestData=getRequestData v-if="formList.voucherRecoverManager" :searchList=formList.voucherRecoverManager>
               <template slot="searchInput">
                <el-select v-model="getRequestData.tpId" placeholder="请选择账套" filterable @change="changeSelect">
              <el-option v-for="item in planList" :key="item.tpId" :label="item.planName" :value="item.tpId"></el-option>
            </el-select>
                            </template>
            </vSearch>
        
      </div>
    </div>
    <div class="">

      <div class="page_content_center">
        <el-table stripe :data="rawData" @selection-change="handleSelectionChange" height="100%" border
          style="width: 100%" highlight-current-row size="mini">
          <el-table-column type="selection" width="40">
          </el-table-column>
          <el-table-column align="center"  v-for="(tableValye, tableKey) in rawField"
            :sortable="tableValye.field == 'dwmch' ? true : false" :key="tableKey" :min-width="tableValye.width"
            show-overflow-tooltip :prop="tableValye.field" :label="tableValye.label">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import Vue from "vue";
import formList from "./voucher";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      formList:formList,
      getRequestData: { // 查询条件
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000, // 开始时间
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1, // 结束时间
        tpId: '', //方案Id
        searchValue: ''
        // planName: '' // 方案名称
      },
      buttonList: [], //权限按钮集合
      activeName: '', // tab选择项
      mutipleSel: ['3'], // 多选选项
      accountSel: '1', // 单选选项
      // 原始数据字段
      rawField: [
        {
          label: '单据编号',
          field: 'djbh',
          width: 150,
        },
        {
          label: '日期',
          field: 'rq',
          width: 120,
        },
        {
          label: '业务员',
          field: 'ywy',
          width: 120,
        },
        {
          label: '单位名称',
          field: 'dwmch',
          width: 160,
        },
        {
          label: '含税金额',
          field: 'hsje',
          width: 120,
        },
        {
          label: '部门名称',
          field: 'bm',
          width: 120,
        },
        {
          label: '操作员',
          field: 'username',
          width: 120,
        },
        {
          label: '摘要',
          field: 'zhy',
          width: 200,
        },
        {
          label: '记账类型',
          field: 'name1',
          width: 120,
        },
        {
          label: '凭证类别',
          field: 'code1',
          width: 120,
        }

      ],
      // 凭证字段
      voucherField: [
        {
          label: '凭证类型',
          field: 'pzlx',
          width: 120,
        },
        {
          label: '日期',
          field: 'rq',
          width: 120,
        },
        {
          label: '单据编号',
          field: 'djbh',
          width: 150,
        },
        {
          label: '摘要',
          field: 'Summary',
          width: 200,
        },
        {
          label: '科目号',
          field: 'Account',
          width: 120,
        },
        {
          label: '含税金额',
          field: 'hsje',
          width: 120,
        },
        {
          label: '借方金额',
          field: 'AmountDr',
          width: 120,
        },
        {
          label: '贷方金额',
          field: 'AmountCr',
          width: 120,
        },
        {
          label: '业务员',
          field: 'ywy',
          width: 120,
        },
        {
          label: 'Currency',
          field: 'Currency',
          width: 120,
        },
        {
          label: 'AuxAccCustomer',
          field: 'AuxAccCustomer',
          width: 120,
        },
        {
          label: 'AuxAccPerson',
          field: 'AuxAccPerson',
          width: 120,
        },
        {
          label: 'AuxAccDepartment',
          field: 'AuxAccDepartment',
          width: 120,
        }
      ],
      planList: [], // 所有方案集合
      rawData: [], // 原始数据列表
      voucherData: [], // 凭证数据列表
      multipleSelection: [], // 原始数据选择项
      detailsList: [],
      postlist: [],
      fieldJson: [
        {
          dataSource: 'djbh', //数据源字段
          voucherField: 'ExternalCode', //凭证字段
          groupType: 'hz', //分组类别
          jdfx: 'wu', //借贷方向
          isCode: false, //IsCode
          isAuxInfos: false, //IsAuxInfos
          label: '凭证单号',
          width: 150,
        },
        {
          dataSource: 'rq',
          voucherField: 'VoucherDate',
          groupType: 'hz',
          jdfx: 'wu',
          isCode: false,
          isAuxInfos: false,
          label: '日期',
          width: 110,
        },
        {
          dataSource: 'zhy',
          voucherField: 'Summary',
          groupType: 'mx',
          jdfx: 'all',
          isCode: false,
          isAuxInfos: false,
          label: '摘要',
          width: 200,
        },
        {
          dataSource: 'kemuhao',
          voucherField: 'Account',
          groupType: 'mx',
          jdfx: 'all',
          isCode: true,
          isAuxInfos: false,
          label: '科目号',
          width: 100,
        },
        {
          dataSource: 'jfje',
          voucherField: 'AmountDr',
          groupType: 'mx',
          jdfx: 'jf',
          isCode: false,
          isAuxInfos: false,
          label: '借方金额',
          width: 120,
        },
        {
          dataSource: 'dfje',
          voucherField: 'AmountCr',
          groupType: 'mx',
          jdfx: 'df',
          isCode: false,
          isAuxInfos: false, //return item.dataSource == i && item.groupType == 'mx' && (jdfx == item.jdfx || item.jdfx == 'all')
          label: '贷方金额',
          width: 120,
        },
        {
          dataSource: 'auxacccustomer',
          voucherField: 'AuxAccCustomer',
          groupType: 'mx',
          jdfx: 'all',
          isCode: true,
          isAuxInfos: true,
          label: '单位编码',
          width: 120,
        },
        {
          dataSource: 'auxaccdepartment',
          voucherField: 'AuxAccDepartment',
          groupType: 'mx',
          jdfx: 'all',
          isCode: true,
          isAuxInfos: true,
          label: '部门',
          width: 120,
        },
        {
          dataSource: 'auxaccperson',
          voucherField: 'AuxAccPerson',
          groupType: 'mx',
          jdfx: 'all',
          isCode: true,
          isAuxInfos: true,
          label: '人员',
          width: 120,
        },
        {
          dataSource: 'auxaccinventorycode',
          voucherField: 'AuxAccInventory',
          groupType: 'mx',
          jdfx: 'all',
          isCode: true,
          isAuxInfos: true,
          label: '商品编码',
          width: 130,
        },
        {
          dataSource: 'quantitydr',
          voucherField: 'QuantityDr',
          groupType: 'mx',
          jdfx: 'jf',
          isCode: false,
          isAuxInfos: false,
          label: '借方数量',
          width: 120,
        },
        {
          dataSource: 'quantitycr',
          voucherField: 'QuantityCr',
          groupType: 'mx',
          jdfx: 'df',
          isCode: false,
          isAuxInfos: false,
          label: '贷方数量',
          width: 120,
        },
        {
          dataSource: 'price',
          voucherField: 'Price',
          groupType: 'mx',
          jdfx: 'all',
          isCode: false,
          isAuxInfos: false,
          label: '单价',
          width: 120,
        },
        {
          dataSource: 'unitName',
          voucherField: 'Unit',
          groupType: 'mx',
          jdfx: 'all',
          isCode: false,
          isAuxInfos: false,
          label: '包装单位',
          width: 120,
        },
        {
          dataSource: 'currency',
          voucherField: 'Currency',
          groupType: 'mx',
          jdfx: 'all',
          isCode: true,
          isAuxInfos: false,
          label: '货币',
          width: 120,
        },
        {
          dataSource: 'name',
          voucherField: 'Name',
          groupType: 'pzlb',
          jdfx: 'wu',
          isCode: false,
          isAuxInfos: false,
          label: '凭证类别名称',
          width: 120,
        },
        {
          dataSource: 'pzlx',
          voucherField: 'Code',
          groupType: 'pzlb',
          jdfx: 'wu',
          isCode: false,
          isAuxInfos: false,
          label: '凭证类别编码',
          width: 120,
        },
      ],
      resList: [], //只生成一张凭证 明细结果集
      mxList: [], //每张生成一张凭证 明细结果集
      group: [],
      totalPsMoney: 0.00, // 总含税金额
      totalSelLength: 0, // 总数
      tpId: '',
      rawDataIds: [], // 原始数据单据编号
      oldList: [],
      groupField: '',
      requesUrl: '',
      imgUrl: '',
      ormId: '',
      isDis: false,
      excelData: [],
      excelNamelist: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    //表格数据写入excel
    export2Excel() {
      this.excelData = JSON.parse(JSON.stringify(this.rawData))
      // this.excelNamelist = JSON.parse(JSON.stringify(this.fieldJson))
      this.excelNamelist = JSON.parse(JSON.stringify(this.rawField))
      var fieldList = []; //所有字段 显示的所有字段
      var namelist = [];
      this.excelNamelist.forEach(item => {
        // if (this.activeName == 'first') {
        //   fieldList.push(item.dataSource)
        // } else {
        //   fieldList.push(item.voucherField)
        // }
        namelist.push(item.label)
        fieldList.push(item.field)
      })
      console.log(this.rawField);
      console.log(namelist, fieldList);
      // 导出业务逻辑 引用封装好的js方法
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("@/assets/excel/Export2Excel");
        //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
        const tHeader = namelist; // 导出的excel表头名信息
        const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
        const list = this.excelData; // 查询的数据list
        // 进行数据json map 格式转换
        const data = this.formatJson(filterVal, list);
        // 调用方法传参      表头名信息 数据  导出的表格名称
        export_json_to_excel(tHeader, data, "凭证数据");


      });
    },
    //格式转换方法
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },
    acc(e) {
      if (e == 1) {
        this.mutipleSel = ['3']
        this.isDis = false
      } else {
        this.mutipleSel = []
        this.isDis = true
      }
      console.log(this.accountSel)
    },
    // 单选改变
    changeSelect() {
      this.planList.forEach(item => {
        if (this.getRequestData.tpId == item.tpId) {
          this.groupField = item.groupField
        }
      })
      this.getDataList()
    },
    // 刷新
    refresh() {
      this.activeName = 'first'
      this.resList = []
      this.voucherData = []
      this.getAllVoucherPlan()
      this.getButtonList()
    },
    //判断是否为对象（仅为对象，不是数组也不是null）
    isObject(exp) {
      return Object.prototype.toString.call(exp) == '[object Object]'
    },
    // 改变多选
    handleSelectionChange(val) {
      this.totalPsMoney = 0
      this.multipleSelection = val;
      this.multipleSelection.forEach(item => {
        this.totalPsMoney = NP.plus(
          this.totalPsMoney,
          Number(item.hsje)
        );
      })
      this.totalSelLength = this.multipleSelection.length
    },
    // 时间
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },
    // 获取所有凭证方案
    async getAllVoucherPlan() {
      let responseData = await this.$http.getQueryPlanrecover({ configId: '1' });
      if (responseData.status == 200) {
        this.planList = responseData.result
        this.getRequestData.tpId = this.planList[0].tpId
        this.groupField = this.planList[0].groupField
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      console.log(actionData)
      switch (actionData.actionType) {

        case 0://恢复
          this.recoverDate()
          break;
        // case 21:
        //   this.generateVoucher()
        //   break;
        // case 22:
        //   this.out()
        //   break;
        // case 23:
        //   this.exportUnitData()
        //   break;
        // case 24:    //导出商品资料
        //   window.location.href = this.requesUrl + `/voucher/exportGoodsData?ormId=${String(this.ormId)}`
        //   break;
        // case 25:    //导出数据
        //   this.export2Excel()
        //   break;
      }
    },
    async recoverDate() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: '请先选择数据！',
          type: "error",
        });
        return 
      }
      if (this.getRequestData.tpId== '' || this.getRequestData.tpId== null ) {
        this.$message({
          message: '无方案',
          type: "error",
        });
        return 
      }
      let params = {
        billNumList: [],
        tpId: this.getRequestData.tpId
      }
      this.multipleSelection.forEach(item => {
        params.billNumList.push(item.djbh)
      })
      let res = await this.$http.recoverQueryVoucherPlanMasterData(params)
      if (res.status == 200) {
           
              this.$message({
                message:res.message,
                type: "success",
              });
              this.activeName = 'first'
              this.voucherData = []
              this.resList = []
              this.getDataList()
            
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
    },
    //获取图片存取的根路径
    imgurl() {
      // console.log(this.$store.getters.getConfig);
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },
    // 导出单位资料
    exportUnitData() {
      window.location.href = this.requesUrl + `/voucher/exportUnitData?ormId=${String(this.ormId)}`
    },
    //导出
    async out() {
      let newList = []
      this.voucherData.forEach(item => {
        newList.push(this.getmx(item))
      })
      // console.log(newList)
      if (newList.length == 0) {
        return this.$message({
          message: '暂无凭证可导出',
          type: "error",
        });
      }
      // this.rawDataIds = []
      if (this.accountSel == 1) {
        let res1 = JSON.parse(JSON.stringify(newList))
        let code = res1[0].Code || "记"
        let ress1 = []
        res1.forEach(item => {
          // this.rawDataIds.push(item.djbh)
          delete item.direction
          delete item.jdfx
          delete item.djbh
          delete item.Code
          delete item.Name
          delete item.ExternalCode
          delete item.VoucherDate
          delete item.id
          if (item.AmountCr != 0 && item.AmountDr != 0) {
            ress1.push(item)
          }
        })
        let hz = {
          "ExternalCode": this.multipleSelection[0].djbh,
          "DocType": { "Code": code },
          "AttachedVoucherNum": res1.length.toString(),
          "Memo": "无",
          "VoucherDate": "2014-09-30",
          "Entrys": ress1,
          "VoucherDate": this.oldList[0].rq
        }
        this.subAllVoucherInfo(hz)
      }
      if (this.accountSel == 2) {
        for (let index = 0; index < this.multipleSelection.length; index++) {
          const item = this.multipleSelection[index];
          console.log(item);

          // this.rawDataIds = []
          let mx = newList.filter(resmx => {
            resmx.djbh == item.djbh
          })
          let res2 = JSON.parse(JSON.stringify(newList))
          let resArr = []
          let code = res2[0].Code || "记"
          res2.forEach(key => {
            if (item.djbh == key.djbh && item.AmountCr != 0 && item.AmountDr != 0) {
              resArr.push(key)
              // this.rawDataIds.push(key.djbh)
            }
            delete key.direction
            delete key.jdfx
            delete key.djbh
            delete key.Code
            delete key.Name
            delete key.ExternalCode
            delete key.VoucherDate
            delete key.id
          })
          let hz = {
            "ExternalCode": item.djbh,
            "DocType": { "Code": code },
            "AttachedVoucherNum": res2.length,
            "Memo": "无",
            "VoucherDate": "2014-09-30",
            "Entrys": resArr,
            "VoucherDate": this.oldList[0].rq
          }
          let params = {
            map: hz,
            tpId: this.getRequestData.tpId,
            billNum: [item.djbh],
            start: this.getRequestData.start,
            end: this.getRequestData.end,
          }
          let responseData = await this.$http.subVoucherInfo(params)
          if (responseData.status == 200) {
            if (index == this.multipleSelection.length - 1) {
              this.$message({
                message: '导出成功',
                type: "success",
              });
              this.activeName = 'first'
              this.voucherData = []
              this.resList = []
              this.getDataList()
            }
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        }
      }
    },
    // 调用T+接口
    async subAllVoucherInfo(info) {
      let params = {
        map: info,
        tpId: this.getRequestData.tpId,
        billNum: this.rawDataIds,
        start: this.getRequestData.start,
        end: this.getRequestData.end,
      }
      console.log('调用T+接口', params);
      let responseData = await this.$http.subVoucherInfo(params)
      if (responseData.status == 200) {
        this.$message({
          message: '导出成功',
          type: "success",
        });
        this.activeName = 'first'
        this.voucherData = []
        this.resList = []
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 生成凭证
    async generateVoucher() {
      // 判断是否有选中数据
      if (this.multipleSelection.length == 0) {
        return this.$message({
          message: '请先选中数据',
          type: "error",
        });
      }
      // if (!this.getDetailsByIds()) return 
      await this.getDetailsByIds()
      this.resList = []
      // let res=[]

      // 循环方案列表 查找对应分组字段
      // this.planList.forEach(item => {
      //     if (item.tpId == this.getRequestData.tpId) {
      //         this.group = item.groupField.split(',')
      //     }
      // })
      //获取转换后明细  20220409改动 最后转换明细
      let mxlist = []
      //   this.detailsList.forEach(item=> {
      //     mxlist.push(this.getmx(item))
      //  })
      this.detailsList.forEach(item => {
        mxlist.push(item)
      })
      //let mx= this.detailsList.map(this.getmx)
      //只生成一张凭证
      if (this.accountSel == 1) {
        // let status = this.pf(this.multipleSelection) // true 没有相同的 false 有相同的
        // if (!status) {
        //     return this.$message({
        //         message: '不同单位不能合并',
        //         type: "error",
        //     });
        // }
        let mx = []
        //合并相同科目
        if (this.mutipleSel.includes('3')) {
          mx = this.recordSummary(mxlist, this.multipleSelection[0].djbh, 0)
          this.resList = mx
        } else {
          this.resList = mxlist
        }
      } else if (this.accountSel == 2) {  //每笔生成一张凭证
        if (this.mutipleSel.includes('3')) {
          this.multipleSelection.forEach((item, index) => {
            //合并相同科目
            let newmx = []
            if (this.mutipleSel.includes('3')) {
              newmx = this.recordSummary(mxlist, item.djbh, 1)
            }
            this.resList = this.resList.concat(newmx)
          })
        } else {
          this.resList = mxlist
        }
      }
      //忽略为0明细
      if (this.mutipleSel.includes('4')) {
        let mx2 = this.resList.filter(item => {
          return item[item.direction == '贷方' ? 'dfje' : 'jfje'] != 0
        })
        this.resList = this.recordSummary(JSON.parse(JSON.stringify(mx2)));
        // this.resList = this.recordSummary(JSON.parse(JSON.stringify(this.resList)));
      }
      // this.voucherData = this.recordSummary(JSON.parse(JSON.stringify(this.resList)))
      this.voucherData = JSON.parse(JSON.stringify(this.resList))
      let df = [], jf = []
      this.voucherData.forEach(keys => {
        if (keys.direction == '借方') {
          jf.push(keys)
        } else {
          df.push(keys)
        }
      })
      this.voucherData = jf.concat(df)
      this.rawDataIds = []
      this.multipleSelection.forEach(key => {
        this.rawDataIds.push(key.djbh)
      })
      console.log('voucherData', this.voucherData)
      this.activeName = 'second'
    },
    recordSummary(arr, djbh, isall) {
      const accKeys = ['jfje', 'dfje'] //number字段
      const searchKeys = this.groupField.split(',') // 合并分组字段
      console.log(searchKeys)
      let list = []
      if (isall == 1) {
        list = arr.filter(item => {
          return item.djbh = djbh
        })
      } else {
        list = JSON.parse(JSON.stringify(arr))
      }
      // console.log('list',list)
      // const searchKeys = ['kemuhao','auxaccdepartment'] // 合并字段
      const res = list.reduce((pre, cur, i) => {
        const findIndex = pre.findIndex(item => {
          return searchKeys.reduce((flag, key) => {
            return flag && item[key] === cur[key]
          }, true)
        })
        if (findIndex > -1) {
          const find = pre[findIndex]
          // console.log(find)
          if (find['direction'] == '贷方' && cur['direction'] == '贷方') {
            find.dfje = NP.plus(
              Number(find.dfje),
              Number(cur.dfje)
            );
            find.dfje = find.dfje.toString()
            if (cur.quantitycr && !isNaN(Number(cur.quantitycr))) {
              find.quantitycr = NP.plus(
                Number(find.quantitycr),
                Number(cur.quantitycr)
              );
              find.quantitycr = find.quantitycr.toString()
            }
            // console.log('find', find.dfje,cur)
          }
          if (find['direction'] == '借方' && cur['direction'] == '借方') {
            // console.log('借方',find.jfje,cur,cur.jfje)
            find.jfje = NP.plus(
              Number(find.jfje),
              Number(cur.jfje)
            );
            find.jfje = find.jfje.toString()
            if (cur.quantitydr && !isNaN(Number(cur.quantitydr))) {
              find.quantitydr = NP.plus(
                Number(find.quantitydr),
                Number(cur.quantitydr)
              );
              find.quantitydr = find.quantitydr.toString()
            }
          }
        } else {
          pre.push({
            ...cur
          })
        }
        return pre
      }, [])
      return res
    },
    //转换凭证明细
    getmx(detail) {
      let da = JSON.parse(JSON.stringify(detail));
      let that = this
      let mx = {}
      let infos = {}
      let jdfx = da.direction == "借方" ? 'jf' : 'df'
      for (let i in da) {
        if (da[i] != null) {
          da[i] = da[i].toString()
        }
        //判断字段是否需要
        let fld = that.fieldJson.find(item => {
          return item.dataSource == i && item.groupType == 'mx' && (jdfx == item.jdfx || item.jdfx == 'all')
        })
        if (fld) {
          if (fld.isAuxInfos) {
            if (fld.isCode) {
              infos[fld.voucherField] = { "Code": da[i] }
            } else {
              infos[fld.voucherField] = da[i]
            }
          } else {
            if (fld.isCode) {
              mx[fld.voucherField] = { "Code": da[i] }
            } else {
              if (fld.dataSource == 'unitName') {
                mx[fld.voucherField] = { "Name": da[i] }
              } else {
                mx[fld.voucherField] = da[i]
              }
            }
          }
        }
      }
      if (JSON.stringify(infos) != '{}') {
        mx['AuxInfos'] = new Array(infos)
      }
      // console.log('detail',detail)
      //添加转换后明细借贷方向
      mx["direction"] = jdfx
      //添加转换后明细借贷方向
      mx["djbh"] = detail.djbh
      mx["ExternalCode"] = detail.djbh
      mx["VoucherDate"] = detail.rq
      mx["Code"] = detail.pzlx || "记";
      mx["Name"] = detail.jzpz || "记账凭证";
      return mx
    },
    
    // 获取对应明细
    async getDetailsByIds() {
      this.oldList = []
      var ids = []
      this.oldList = this.multipleSelection //已经选中得数据
      this.multipleSelection.forEach(item => {
        ids.push(item.djbh)
      })
      let params = {
        tpId: this.getRequestData.tpId,
        ids: ids,
        start: this.getRequestData.start,
        end: this.getRequestData.end,
      }
      let responseData = await this.$http.getDetailsByIds(params)
      if (responseData.status == 200) {
        this.detailsList = responseData.rows
        // console.log('明细', this.detailsList)
        if (this.detailsList.length == 0) {
          return this.$message({
            message: '未找到明细',
            type: "error",
          });
        }
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
      return this.detailsList
    },
    pf(arr) {
      let dwmc = arr[0].dwmch
      for (let index = 0; index < arr.length; index++) {
        if (arr[index].dwmch != dwmc) {
          return false
        }
      }
      return true
    },
    // 获取数据列表
    async getDataList() {
      this.activeName = 'first'
      this.voucherData = []
      this.resList = []
      let params = JSON.parse(JSON.stringify(this.getRequestData))
      let responseData = await this.$http.getQueryVoucherPlanMasterData(params)
      if (responseData.status == 200) {
        this.rawData = responseData.rows

      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 获取权限按钮
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton();
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
    for (const key in obj) {
      this.$set(this.getRequestData, key, obj[key])
    }
    this.ormId = sessionStorage.getItem('ormId')
    this.activeName = "first"
    this.imgurl()
    this.getButtonList()
    this.getAllVoucherPlan()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.el-drawer {
  outline: none;
}

.dis {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.page_content_center {
  height: 72vh;
}

.dissp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.num {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  margin-right: 5%;
}

.money {
  margin-left: 50px;
}

.ttred {
  color: red;
}
</style>